/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { workspacesUpdate } from "../../funcs/workspacesUpdate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .PutApiLeadScraperMicroserviceApiV1WorkspaceRequestBody$inboundSchema,
};

export const tool$workspacesUpdate: ToolDefinition<typeof args> = {
  name: "workspaces_update",
  description: `Update workspace details

Updates the details of a specific workspace`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await workspacesUpdate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
